function ReportFilterListViewData(aLabelName, aIsRequired, aText, aValue, aId) {
    "use strict";
    this.Id = aId;
    this.LabelName = aLabelName;
    this.IsRequired = aIsRequired;
    this.Text = aText;
    this.Value = aValue;
}
if (typeof exports !== 'undefined') {
    module.exports = ReportFilterListViewData;
}